import React, { useContext, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CalloutMemo } from '@fluid/callouts';
import { FormLayoutFieldContainer } from '@fluid/layouts';
import { errorHelper, getMessageDependencies } from '../utils/ErrorUtils';
import LoginContext from '../context/LoginContext';

const LoginError = (props) => {
    const { legacyLoginConfig = {} } = props;
    const [messageConfig, setMessageConfig] = useState(undefined);
    const prevLegacyLoginConfig = useRef(legacyLoginConfig);
    const { context, setContext } = useContext(LoginContext);

    useEffect(() => {
        const { cookieEnabled } = window.navigator;

        if (!cookieEnabled) {
            const { cookiesDisabledInstruction, cookiesDisabledMessage } =
                legacyLoginConfig ?? {};
            setMessageConfig({
                type: 'ERROR',
                title: cookiesDisabledMessage,
                message: cookiesDisabledInstruction,
            });
            setContext({ ...context, cookieDisabled: true });
        } else if (legacyLoginConfig.logoutTitle) {
            let { logoutMessageType } = legacyLoginConfig;
            const { timeout, logout } = legacyLoginConfig;

            if (timeout === 'timeout') {
                logoutMessageType = 'WARNING';
            } else if (logout === 'logout') {
                logoutMessageType = 'INFO';
            } else if (typeof logoutMessageType === 'undefined') {
                logoutMessageType = 'ERROR';
            }
            setMessageConfig({
                title: legacyLoginConfig.logoutTitle,
                message: legacyLoginConfig.logoutMessage,
                type: logoutMessageType,
            });
        } else {
            const errorConfig = errorHelper(legacyLoginConfig);

            if (errorConfig) {
                const {
                    component: messageComponent,
                    shoulClearMessageOnPasswordChange,
                } = errorConfig;

                // clear out temp passowrd expired messages when user types on in the password field
                // if a new legacyConfig is passed in, show the error again
                if (
                    context.passwordValueChanged &&
                    shoulClearMessageOnPasswordChange &&
                    prevLegacyLoginConfig.current === legacyLoginConfig
                ) {
                    setMessageConfig(undefined);
                    prevLegacyLoginConfig;
                } else {
                    prevLegacyLoginConfig.current = legacyLoginConfig;
                    setMessageConfig({ messageComponent, type: 'ERROR' });
                }
            }
        }
    }, getMessageDependencies(legacyLoginConfig).concat(context.passwordValueChanged));

    if (!messageConfig) {
        return false;
    }

    const { messageComponent, type, title, message } = messageConfig;

    if (!messageComponent && !title && !message) {
        return false;
    }

    let iconCls = 'fluid-icon-exclamation-triangle';

    if (type === 'INFO') {
        iconCls = 'fluid-icon-info-circle';
    }

    if (messageComponent) {
        return (
            <FormLayoutFieldContainer>
                <CalloutMemo type={type}>{messageComponent}</CalloutMemo>
            </FormLayoutFieldContainer>
        );
    }

    return (
        <FormLayoutFieldContainer>
            <CalloutMemo
                type={type}
                title={title}
                msg={message}
                iconCls={iconCls}
            />
        </FormLayoutFieldContainer>
    );
};

LoginError.defaultProps = {};

LoginError.propTypes = {
    legacyLoginConfig: PropTypes.object,
};

export default LoginError;
